<template>
    <div class="z-lead" :class="classObject">
        <slot></slot>
    </div>
</template>

<script setup>
import {computed} from 'vue'

const props = defineProps({
    colouredBg: {
        type: Boolean,
        default: false
    },
    decorSide: {
        type: String,
        default: 'left',
        validator: (prop) => ['left', 'top', 'bottom'].includes(prop)
    },
    decor: {
        type: Boolean,
        default: true
    }
})

const classObject = computed(() => {
    return ({
        'z-lead--coloured-bg': props.colouredBg,
        [`z-lead--with-decor z-lead--with-decor-${props.decorSide}`]: props.decor && props.decorSide
    })
})

defineExpose({
    props
})
</script>

<style lang="scss" src="./index.scss">
</style>
